export default __webpack_public_path__ + "static/media/laptop@2x.4c1f86ac.png";